var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: " grid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 19V15H19L19.001 19H15ZM19 13.0001H15C13.897 13.0001 13 13.8971 13 15.0001V19.0001C13 20.1031 13.897 21.0001 15 21.0001H19C20.103 21.0001 21 20.1031 21 19.0001V15.0001C21 13.8971 20.103 13.0001 19 13.0001ZM5 19V15H9L9.001 19H5ZM9.00001 13.0001H5.00001C3.897 13.0001 3.00001 13.8971 3.00001 15.0001V19.0001C3.00001 20.1031 3.897 21.0001 5.00001 21.0001H9.00001C10.103 21.0001 11 20.1031 11 19.0001V15.0001C11 13.8971 10.103 13.0001 9.00001 13.0001ZM15 9V5H19L19.001 9H15ZM19 3.00008H15C13.897 3.00008 13 3.89708 13 5.00008V9.00008C13 10.1031 13.897 11.0001 15 11.0001H19C20.103 11.0001 21 10.1031 21 9.00008V5.00008C21 3.89708 20.103 3.00008 19 3.00008ZM5 9V5H9L9.001 9H5ZM9 3H5C3.897 3 3 3.897 3 5V9C3 10.103 3.897 11 5 11H9C10.103 11 11 10.103 11 9V5C11 3.897 10.103 3 9 3Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/Grid.1b1b560baf64e4d5a5e349cd5d8d6e7a.svg";
export { ForwardRef as ReactComponent };